import { defineAction } from '~/prix'
import fetchQuestionnaireAnswersAction from './questionnaireFetchAnswers.action.json' with { type: 'json' }
import { z } from 'zod'
import { questionnaireObject } from '../questionnaireObject'

const fetchQuestionnaireAnswersDefinition = defineAction({
  ...fetchQuestionnaireAnswersAction,

  input: z.object({
    questionnaireId: z.number().describe('ID do questionário'),
    cns: z.string().describe('CNS do cidadão'),
    cpf: z.string().describe('CPF do cidadão'),
  }),
  output: z.object({
    form: z.object({
      title: z.string().describe('Título do formulário'),
      questionnaires: z.array(
        questionnaireObject.pick({
          title: true,
          questions: true,
        }),
      ),
    }),
  }),
})

export default fetchQuestionnaireAnswersDefinition
